<template>
  <div class="confirmation-guide-wrap">
    <VHeader></VHeader>
    <div class="content">
      <div class="tips">
        <i class="el-icon-warning"></i>
        {{ $t('confirmationGuideTips') }}
      </div>
      <div class="list">
        <template v-for="(bank, index) in hasPdfList">
          <a :key="index" :href="'/static/confirmation/' + bank + '.pdf'" target="_blank"
              :style="pdfNameMap[bank.slice(0, 6)] ? {} : { 'pointer-events': 'none', color: '#b7b4b4' }">
            <span class="index">{{ index + 1 }}. </span>
            <i v-if="pdfNameMap[bank.slice(0, 6)]" class="el-icon-download"></i>
            {{ bank }} {{ `${pdfNameMap[bank.slice(0, 6)] ? '.pdf' : ''}` }}
          </a>
        </template>
      </div>
    </div>
    <VBottom></VBottom>
  </div>
</template>

<script>
import pdfNameMap from '../pdf/pdfNameMap'
import allBankMapWithSort from '../pdf/allBankMapWithSort'
import VHeader from '@/components/common/HeaderNoLogin.vue'
import VBottom from '@/components/common/Bottom'
import SvgIcon from '@/components/svgIcon/index'

export default {
  components: {
    VHeader,
    VBottom,
    SvgIcon
  },
  data() {
    return {
      pdfNameMap,
      allBankMapWithSort,
    }
  },
  computed: {
    fileList() {
      return Object.values(this.pdfNameMap)
    },
    hasPdfList() {
      return Object.values(this.allBankMapWithSort).filter(bank => pdfNameMap[bank.slice(0, 6)])
    },
  },
}
</script>

<style scoped>
.confirmation-guide-wrap {
  width: 100%;
  height: 100%;
  background-color: #ebebeb;
}

.confirmation-guide-wrap .content {
  width: 50%;
  margin: 0 auto;
  height: calc(100% - 70px - 46PX);
  background-color: #fff;
  padding: 20px 0;
}

.confirmation-guide-wrap .content h2,
.confirmation-guide-wrap .content .tips {
  padding: 0 20px;
}

.confirmation-guide-wrap .content .tips {
  color: #fd349c;
}

.confirmation-guide-wrap .content .list {
  margin-top: 20px;
  height: calc(100% - 40px);
  overflow-y: auto;
  padding-left: 20px;
}

.confirmation-guide-wrap .content .list::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8PX !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8PX !important;
}

.confirmation-guide-wrap .content a {
  display: block;
  height: 30PX;
  color: #000;
  line-height: 30PX;
  padding-right: 10px;
}

.confirmation-guide-wrap .content a:hover {
  color: #3879eb;
  background-color: #f7f7f7;
}

.confirmation-guide-wrap .content a i {
  color: #3879eb;
  font-weight: 600;
}

.confirmation-guide-wrap .content a .index {
  display: inline-block;
  width: 25px;
  text-align: right;
  margin-right: 10px;
}
</style>